import messagesEn from './i18n/messages.en'

export const messages = {
  en: {
    ...messagesEn
  }
}
